import React from 'react';
import trackEvent, {ACTIONS, CATEGORIES} from "../tracking/trackEvent";

export default function FooterLinks({ links }: { links: Array<{ label: string; href: string; }>}) {
    return (
        <ul className="mb-5">
            {links.map(({href, label}) => (
                <li key={href}>
                    <a
                        href={href}
                        target={href.indexOf('https://') > -1 ? '_blank' : '_self'}
                        onClick={() => trackEvent(CATEGORIES.CLICK, ACTIONS.FOOTER_LINK, label)}
                    >
                        {label}
                    </a>
                </li>
            ))}
        </ul>
    );
}
